module.exports = __webpack_public_path__ + "img/logo-mandiri.ad73a277.png";